<div class="modal-content">
  <div class="modal-header">
    <div class="modal-header-left">
      <h4 style="font-size: 25px; font-weight: bold">{{ isBulkupdate ? 'Bulk-':''}}Update Result</h4>
    </div>
    <div class="modal-header-right">
      <button type="button" class="close" (click)="close()">
        <i class="icon-close"></i>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <div class="modal-body-inner">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            Number of success: {{ response?.updated_recs }}
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12">
            Number of errors: {{ response?.errors }}
          </div>
        </div>
        <div *ngIf="response?.error_msg" class="row">
          <div class="col-lg-12 col-md-12 mt-4">
            <h4>Error Messages:</h4>
            <div class="ml-4">
              <ul>
                <li *ngFor="let message of response?.error_msg">
                  {{ message }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
